<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form  :model="descDetail" ref="descDetail"  label-width="0px" class="demo-dynamic form-horizontal detailPage">

      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in descDetail.langMap"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Announcement Title
                </label>
                <div class="col-sm-10" >
                  <el-form-item 
                      :prop="'langMap.' + index + '.title'"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                    <el-input v-model="langItem.title" show-word-limit  :maxlength="langItem.langCode=='en_US'?24:18"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Announcement Message 
                </label>
                <div class="col-sm-10" >
                  <el-form-item 
                      :prop="'langMap.' + index + '.message'"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                    <el-input v-model="langItem.message" show-word-limit  :maxlength="langItem.langCode=='en_US'?50:26"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Button Name
                </label>
                <div class="col-sm-10" >
                  <el-form-item 
                      :prop="'langMap.' + index + '.buttonName'"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                    <el-input v-model="langItem.buttonName" show-word-limit  :maxlength="langItem.langCode=='en_US'?26:24"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Status
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="status"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-select v-model="descDetail.status" clearable >
                        <el-option 
                        v-for="item in statusObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" v-if="checkPermission('TRANSPORTATION_SAVE')" @click="checkEvent()">{{$t("message.Save") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";
import draggable from 'vuedraggable'

import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      descDetail:{
        status:"",
        type:1,
        langMap:[{
          message:"",
          buttonName:"",
          urlForMoreInfo:"",
          title:"",
          langCode:'en_US'
        },{
          message:"",
          buttonName:"",
          urlForMoreInfo:"",
          title:"",
          langCode:'zh_CN'
        },{
          message:"",
          buttonName:"",
          urlForMoreInfo:"",
          title:"",
          langCode:'zh_HK'
        }],
      },
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'Heading', 'bold', 'italic','underline','Link', 'bulletedList', 'numberedList' ],
         // extraPlugins: [ upload.MyCustomUploadAdapterPlugin ]
          // The configuration of the editor.
      },
      activeNamesBasis:['4'],
      statusObj:[]
    };
  },
  computed:{
      _language(){
        return this.$store.state.userInfo.langCode
      }
  },
  watch: {
    _language:function(){
      this.setObj();
    },
    descDetail: {
        handler: function(val, oldval) {
          this.$store.state.edit = true;
        },
        deep: true
    }
  },
  components: {
    draggable,
    "file-upload": fileupload
  },
  created() {
    this.setObj();
    this.init();
    this.statusObj=[{
      value: 1,
      label: 'Active'
    }, {
      value: 0,
      label: 'Inactive'
    }]
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
        );
    },
    setObj:function(){
    },
    async init() {
        let obj = this.getAuthObj();
        obj.type = 2;
        obj.apiUrl = '/getTipsReminders'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        
        if(data.data.result==null){
          data.data.result = {
            status:"",
            type:2,
            langMap:[{
              message:"",
              buttonName:"",
              urlForMoreInfo:"",
              title:"",
              langCode:'en_US'
            },{
              message:"",
              buttonName:"",
              urlForMoreInfo:"",
              title:"",
              langCode:'zh_CN'
            },{
              message:"",
              buttonName:"",
              urlForMoreInfo:"",
              title:"",
              langCode:'zh_HK'
            }],
          }
        }
        this.descDetail = data.data.result;
        var that = this;
        setTimeout(function(){
          that.$store.state.edit = false;
        },500)
    },
    checkEvent:function(){
        this.$refs["descDetail"].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            this.$toastr.w(this.$i18n.t("message.fillRequired"));
            return false;
          }
        });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for(var key in this.descDetail){
          var detail = JSON.stringify(this.descDetail[key])
          obj[key] = JSON.parse(detail);
        }
        obj.visualData = JSON.stringify(obj.visualData);
        obj.langMap = JSON.stringify(obj.langMap);
        obj.apiUrl = '/saveTipsReminders'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.$toastr.s("Success");
        }
      } catch (err) {
      }
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    }
  }
};
</script>
